import { createFileRoute } from "@tanstack/react-router"
import { OrganisationTree } from "./-component"

export const Route = createFileRoute("/app/admin-settings/organisation/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <OrganisationTree />
}
